:host {
  display: block;
}

select {
  border-bottom: 0;
}

#categories-dropdown {
  width: 296px;
  margin-left: 2px; // line up with cards

  @include agl-ds-screen-size('medium') {
    display: none;
  }
}

.categories-container {
  display: flex;
  align-content: center;
  justify-content: center;
  padding-top: 10px;
  font-family: 'Open Sans', sans-serif;
  font-size: 16px;
  font-weight: 600;
  line-height: 1.25;

  &.change-plan {
    padding-top: 0;
    margin-top: $space-06;
  }
}

#categories-buttons {
  display: none;

  @include agl-ds-screen-size('medium') {
    display: flex;
    align-content: center;
    justify-content: center;
    border-bottom: solid 1px #d8d8d8;
  }
}

button {
  background-color: transparent;
  padding: 12px 16px;
  min-width: 176px;
  cursor: pointer;
  border-radius: 8px 8px 0 0;
  font-size: 16px;
  color: black;

  &.selected {
    color: white;
    background-color: #001cb0;
    cursor: inherit;
  }
}

button:not(:last-child) {
  margin-right: 32px;
}
